if (!customElements.get("announcement-banner")) {
  customElements.define(
    "announcement-banner",
    class AnnouncementBanner extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        const announcementBar = this;
        const pauseButton = this.querySelector(
          ".collection-announcement-bar .pause-btn"
        );
        const announcementWrapper = this.querySelector(".announcement-wrapper");
        const logo = document.querySelector("custom-header .logo");
        logo.classList.add("scrolled-into-view");
        const mainNav = document.querySelector(
          "custom-header .main-nav-container"
        );

        announcementBar.addEventListener("click", pause);
        function pause() {
          if (announcementWrapper.classList.contains("paused")) {
            announcementWrapper.classList.remove("paused");
            pauseButton.innerHTML =
              '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="_icon_17f2n_306" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 21H5V3h5v18ZM9 4v16H6V4h3ZM19 21h-5V3h5v18ZM18 4v16h-3V4h3Z"></path></svg>';
          } else {
            announcementWrapper.classList.add("paused");
            pauseButton.innerHTML =
              '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="_icon_17f2n_306" aria-hidden="true"><path d="M6 3.634 20.5 12 6 20.366V3.634Zm1 1.732v13.268L18.5 12 7 5.366Z"></path></svg>';
          }
        }

        const observerOptions = {
          root: null,
          rootMargin: "0px",
          threshold: 0.1,
        };

        const observer = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              mainNav.classList.add("scrolled-into-view");
            } else {
              mainNav.classList.remove("scrolled-into-view");
            }
          });
        }, observerOptions);

        observer.observe(announcementBar);
      }
    }
  );
}
